import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    padding-bottom: 20px;
    max-width: 400px;
    margin: 0 auto;

    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const LogosWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const AckoLogoWrapper = styled.div`
    display: flex;
    flex: 1;
`;

export const PartnerLogoWrapper = styled.div`
    display: flex;
    flex: 1;
    margin: 0 5px;
`;

export const HamburgerWrapper = styled.div`
    display: flex;
    flex: 2;
    justify-content: flex-end;
`;
